"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBloodPressureFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M7.008 13.918A6.002 6.002 0 018 2a6 6 0 011 11.917c.01 1.64.083 2.634.22 2.983.6 1.8 2.28 3.01 4.28 3.01 2.5 0 4.5-2 4.5-4.5V14c-1.16-.41-2-3.71-2-5a3 3 0 016 0c0 1.29-.84 4.58-2 5v1.5a6.499 6.499 0 01-6.5 6.5c-3.08 0-5.74-2.08-6.36-5.09-.074-.371-.118-1.368-.132-2.992zM8.2 5.666l-1 1.732c-.333.577-.211 1.033.366 1.366.577.333 1.033.211 1.366-.366l1-1.732c.333-.577.211-1.033-.366-1.366-.577-.333-1.033-.211-1.366.366z' }))); };
exports.default = SvgBloodPressureFilled;
//# sourceMappingURL=BloodPressureFilled.js.map